export const ResultsAdapter = results => {
  const resultset = {}
  results.items.map(r => {
    const key = `${r.title}`
    resultset[key] = r
  })
  console.log(resultset)

  return {
    ...results,
    items: {
      ...resultset
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/quiz/adapters/results.adapter.js